import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { typography } from '@shared/tokens/typography.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-16'],
  },
  title: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeHeading-4'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
  },
  text: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  codeBlock: {
    display: 'flex',
    padding: '8px 16px 24px 16px',
    justifyContent: 'center',
    gap: anatomy['size-24'],
    color: colors.primaryText,
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: anatomy['size-12'],
  },
  rowContainer: {
    display: 'flex',
    gap: anatomy['size-24'],
  },
  codePart: {
    display: 'flex',
    gap: anatomy['size-8'],
    height: '44px',
  },
  codePartsContainer: {
    display: 'flex',
    gap: anatomy['size-24'],
  },

  errorText: {
    color: colors.errorText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-2'],
    textAlign: 'center',
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: anatomy['size-8'],
  },
  charBlock: {
    display: 'flex',
    justifyContent: 'center',
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeHeading-4'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
    width: '39.5px',
  },
  normalBorder: {
    borderBottom: `1px solid ${colors.accentBorder}`,
  },
  errorBorder: {
    borderBottom: `1px solid ${colors.errorBorder}`,
  },
});
